/* The Whiskey Wrangler Mercantile — front-end behaviour
   - AJAX quick-add for any <form class="ww-add">
   - "Add all" buttons via [data-ww-add-ids]
   - live header cart-count refresh
   Degrades gracefully: if fetch fails, native form submit takes over. */
(function () {
  function root() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  }

  // A hung request (flaky connection, not an outright failure) would
  // otherwise leave an "Adding…" button stuck forever, since fetch only
  // rejects on a real network error. Force a rejection after `ms` so the
  // existing .catch() fallbacks (native form submit / re-enable button)
  // always get a chance to run.
  function fetchWithTimeout(url, opts, ms) {
    var controller = window.AbortController ? new AbortController() : null;
    var timer = setTimeout(function () { if (controller) { controller.abort(); } }, ms || 8000);
    var merged = {};
    for (var k in opts) { if (opts.hasOwnProperty(k)) { merged[k] = opts[k]; } }
    if (controller) { merged.signal = controller.signal; }
    return fetch(url, merged).then(
      function (r) { clearTimeout(timer); return r; },
      function (err) { clearTimeout(timer); throw err; }
    );
  }

  function refreshCount() {
    return fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-ww-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          if (cart.item_count > 0) { el.removeAttribute('hidden'); }
          else { el.setAttribute('hidden', ''); }
        });
        return cart;
      })
      .catch(function () { return null; });
  }

  function formatMoney(cents) {
    var amt = (cents || 0) / 100;
    return '$' + amt.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function escapeHtml(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function drawer() { return document.getElementById('ww-cart-drawer'); }

  function openDrawer() {
    var d = drawer();
    if (!d) return false;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    return true;
  }

  function closeDrawer() {
    var d = drawer();
    if (!d) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
  }

  function renderCart() {
    var d = drawer();
    if (!d) return refreshCount();
    var body = d.querySelector('[data-ww-cart-body]');
    var foot = d.querySelector('[data-ww-cart-foot]');
    var sub = d.querySelector('[data-ww-cart-subtotal]');
    return fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-ww-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          if (cart.item_count > 0) { el.removeAttribute('hidden'); } else { el.setAttribute('hidden', ''); }
        });
        if (!cart.items || cart.items.length === 0) {
          if (body) { body.innerHTML = '<p class="ww-drawer__empty">Your bag is empty.</p>'; }
          if (foot) { foot.setAttribute('hidden', ''); }
          return cart;
        }
        var html = '';
        cart.items.forEach(function (it) {
          var imgSrc = it.image ? it.image.replace(/(_\d+x\d*)?(\.[a-z]+)(\?.*)?$/i, '_160x$2$3') : '';
          var img = imgSrc ? '<img src="' + escapeHtml(imgSrc) + '" alt="" width="64" height="80">' : '<span></span>';
          var opt = (it.variant_title && it.variant_title.indexOf('Default') === -1) ? '<div class="ww-drawer__iopt">' + escapeHtml(it.variant_title) + '</div>' : '';
          var url = escapeHtml(it.url);
          html += '<div class="ww-drawer__item">' +
            '<a href="' + url + '">' + img + '</a>' +
            '<div><a class="ww-drawer__iname" href="' + url + '">' + escapeHtml(it.product_title) + '</a>' + opt +
            '<div class="ww-drawer__iqty">Qty ' + it.quantity + '</div></div>' +
            '<div class="ww-drawer__iprice">' + formatMoney(it.final_line_price) + '</div>' +
            '</div>';
        });
        if (body) { body.innerHTML = html; }
        if (sub) { sub.textContent = formatMoney(cart.total_price); }
        if (foot) { foot.removeAttribute('hidden'); }
        return cart;
      })
      .catch(function () { return null; });
  }

  // Confirm an add: open the drawer (preferred) or fall back to a toast
  function confirmAdd(msg) {
    if (drawer()) { renderCart().then(openDrawer); }
    else { refreshCount(); showToast(msg); }
  }

  // Drawer controls: open via cart icon, close via overlay/button/Esc
  document.addEventListener('click', function (e) {
    var opener = e.target.closest && e.target.closest('[data-ww-cart-open]');
    if (opener) {
      if (!drawer()) return; // no drawer -> let the link go to /cart
      e.preventDefault();
      renderCart().then(openDrawer);
      return;
    }
    if (e.target.closest && e.target.closest('[data-ww-cart-close]')) { closeDrawer(); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    // Checks is-open, not :not([hidden]) - a just-cancelled gate dialog
    // stays un-hidden for 280ms while it fades out (see createAckGate's
    // close()), and with two independent gate dialogs now possible on
    // the page, :not([hidden]) could find that fading one instead of
    // whichever is genuinely open.
    if (document.querySelector('#ww-hmack.is-open')) { handmadeGate.close(false); return; }
    if (document.querySelector('#ww-preack.is-open')) { preorderGate.close(false); return; }
    if (!closeSizeGuide()) { closeDrawer(); }
  });

  // Size guide dialog (PDP) — focus moves in on open, is trapped while open,
  // and returns to the trigger on close (WCAG dialog pattern; the cart drawer
  // above doesn't need this since it's not a role="dialog").
  var sizeGuideOpener = null;

  function focusable(container) {
    return Array.prototype.slice.call(
      container.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])')
    ).filter(function (el) { return el.offsetParent !== null; });
  }

  function openSizeGuide(trigger) {
    var target = document.getElementById(trigger.getAttribute('aria-controls'));
    if (!target) return;
    sizeGuideOpener = trigger;
    target.removeAttribute('hidden');
    var f = focusable(target);
    (f[0] || target).focus();
  }

  function closeSizeGuide() {
    var open = document.querySelector('.ww-size-guide:not([hidden])');
    if (!open) return false;
    open.setAttribute('hidden', '');
    if (sizeGuideOpener) { sizeGuideOpener.focus(); sizeGuideOpener = null; }
    return true;
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest && e.target.closest('[aria-haspopup="dialog"][aria-controls]');
    if (trigger && trigger.classList.contains('ww-size-guide-trigger')) { openSizeGuide(trigger); return; }
    if (e.target.closest && e.target.closest('[data-ww-size-guide-close]')) { closeSizeGuide(); }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab') return;
    var open = document.querySelector('.ww-size-guide:not([hidden])') || document.querySelector('#ww-hmack.is-open') || document.querySelector('#ww-preack.is-open');
    if (!open) return;
    var f = focusable(open);
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  // Purchase-acknowledgment dialogs (see snippets/ww-handmade-ack.liquid,
  // ww-preorder-ack.liquid) — same WCAG dialog pattern as the size guide
  // above (focus in, trapped, returned to the trigger on close), reusing
  // its focusable() helper and the Tab/Escape handlers above. Gate the
  // PDP "Add to bag" button and single-variant card quick-add for
  // handmade-/pre-order-tagged products; require acknowledgment on every
  // add (no "remembered" dismissal), since this is a liability/CS
  // safeguard, not a one-time FYI.
  //
  // createAckGate is a shared ENGINE (open/close/focus/timer state
  // machine), not shared markup - each dialog keeps its own independent
  // ids (ww-hmack vs ww-preack) and its own <style> block. That's
  // deliberate: a theme-sync problem on one dialog's snippet file must
  // never be able to silently take the other one down too (see
  // VERSION.txt v3.49 for exactly that happening to a single dialog).
  // sections/main-product.liquid also guarantees at most one of the two
  // gates ever applies to the same product (pre-order wins if a product
  // matches both tags), so these two gates are never chained/sequenced -
  // only one ever opens per add-to-cart attempt, by explicit request.
  function createAckGate(dialogId, checkboxId, confirmId) {
    var opener = null, callback = null, hideTimer = null;
    function dialog() { return document.getElementById(dialogId); }
    function open(trigger, onDecide) {
      var dlg = dialog();
      if (!dlg) { onDecide(true); return; } // setting is off - nothing to gate on
      // A cancel-then-immediately-re-click within 280ms would otherwise
      // leave the old close()'s pending hide still queued, which would
      // re-hide this dialog right after it reopens.
      if (hideTimer) { clearTimeout(hideTimer); hideTimer = null; }
      opener = trigger;
      callback = onDecide;
      var checkbox = document.getElementById(checkboxId);
      var confirmBtn = document.getElementById(confirmId);
      checkbox.checked = false;
      confirmBtn.disabled = true;
      dlg.removeAttribute('hidden');
      requestAnimationFrame(function () {
        dlg.classList.add('is-open');
        checkbox.focus();
      });
    }
    function close(decision) {
      var dlg = dialog();
      if (!dlg || dlg.hasAttribute('hidden')) return;
      dlg.classList.remove('is-open');
      hideTimer = setTimeout(function () { dlg.setAttribute('hidden', ''); hideTimer = null; }, 280);
      if (opener) { opener.focus(); opener = null; }
      var cb = callback;
      callback = null;
      if (cb) { cb(decision); }
    }
    return { open: open, close: close };
  }

  var handmadeGate = createAckGate('ww-hmack', 'ww-hmack-checkbox', 'ww-hmack-confirm');
  var preorderGate = createAckGate('ww-preack', 'ww-preack-checkbox', 'ww-preack-confirm');

  document.addEventListener('change', function (e) {
    if (e.target && e.target.id === 'ww-hmack-checkbox') {
      var confirmBtn = document.getElementById('ww-hmack-confirm');
      if (confirmBtn) { confirmBtn.disabled = !e.target.checked; }
    } else if (e.target && e.target.id === 'ww-preack-checkbox') {
      var confirmBtn2 = document.getElementById('ww-preack-confirm');
      if (confirmBtn2) { confirmBtn2.disabled = !e.target.checked; }
    }
  });

  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[data-ww-hmack-cancel]')) { handmadeGate.close(false); return; }
    if (e.target.closest && e.target.closest('[data-ww-preack-cancel]')) { preorderGate.close(false); return; }
    var hmConfirm = e.target.closest && e.target.closest('#ww-hmack-confirm');
    if (hmConfirm && !hmConfirm.disabled) { handmadeGate.close(true); return; }
    var preConfirm = e.target.closest && e.target.closest('#ww-preack-confirm');
    if (preConfirm && !preConfirm.disabled) { preorderGate.close(true); }
  });

  // Prominent confirmation so shoppers don't re-click (prevents accidental double-adds)
  function showToast(msg) {
    var existing = document.getElementById('ww-toast');
    if (existing) { existing.remove(); }
    var t = document.createElement('div');
    t.id = 'ww-toast';
    t.setAttribute('role', 'status');
    t.setAttribute('aria-live', 'polite');
    t.style.cssText = 'position:fixed;z-index:99999;left:50%;bottom:26px;transform:translateX(-50%) translateY(14px);background:#241a10;color:#f7f1e6;font-family:inherit;font-size:15px;line-height:1.2;padding:14px 20px;border-radius:11px;box-shadow:0 12px 34px rgba(0,0,0,.28);display:flex;align-items:center;gap:16px;opacity:0;transition:opacity .25s ease,transform .25s ease;max-width:92vw;';
    var span = document.createElement('span');
    span.textContent = msg;
    t.appendChild(span);
    var link = document.createElement('a');
    link.href = root() + 'cart';
    link.textContent = 'View bag \u2192';
    link.style.cssText = 'color:#e0a06a;text-decoration:none;font-weight:600;white-space:nowrap;';
    t.appendChild(link);
    document.body.appendChild(t);
    requestAnimationFrame(function () {
      t.style.opacity = '1';
      t.style.transform = 'translateX(-50%) translateY(0)';
    });
    setTimeout(function () {
      t.style.opacity = '0';
      t.style.transform = 'translateX(-50%) translateY(14px)';
      setTimeout(function () { if (t.parentNode) { t.remove(); } }, 320);
    }, 3200);
  }

  // Collection sort — navigate reliably, preserve other params, reset to page 1
  document.addEventListener('change', function (e) {
    var sel = e.target;
    if (!sel || !sel.matches || !sel.matches('[data-ww-sort]')) return;
    try {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sel.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    } catch (err) {
      if (sel.form) { sel.form.submit(); }
    }
  });

  // Quick-add / product add-to-cart
  function submitAddForm(form, btn) {
    var label = btn ? btn.innerHTML : '';
    if (btn) { btn.innerHTML = 'Adding…'; btn.disabled = true; }
    fetchWithTimeout(root() + 'cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form)
    })
      .then(function (r) { if (!r.ok) throw r; return r.json(); })
      .then(function () {
        if (btn) { btn.innerHTML = '\u2713 Added'; }
        confirmAdd('\u2713 Added to bag');
        setTimeout(function () { if (btn) { btn.innerHTML = label; btn.disabled = false; } }, 1600);
      })
      .catch(function () { form.submit(); });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.classList || !form.classList.contains('ww-add')) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    if (btn && btn.disabled) return;
    // At most one of these two attributes is ever present on the same
    // button - sections/main-product.liquid computes the two gates as
    // mutually exclusive, so there's no case to chain/sequence here.
    if (btn && btn.hasAttribute('data-ww-handmade-ack')) {
      handmadeGate.open(btn, function (confirmed) {
        if (!confirmed) return;
        // Only enable the acknowledgment field once the box is actually
        // checked, so a submitted order only ever carries it when the
        // shopper confirmed - see sections/main-product.liquid.
        var field = form.querySelector('[data-ww-handmade-ack-field]');
        if (field) { field.disabled = false; }
        submitAddForm(form, btn);
      });
      return;
    }
    if (btn && btn.hasAttribute('data-ww-preorder-ack')) {
      preorderGate.open(btn, function (confirmed) {
        if (!confirmed) return;
        var field = form.querySelector('[data-ww-preorder-ack-field]');
        if (field) { field.disabled = false; }
        submitAddForm(form, btn);
      });
      return;
    }
    submitAddForm(form, btn);
  });

  // "Add all to bag" (stylist look)
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-ww-add-ids]');
    if (!b) return;
    var ids = (b.getAttribute('data-ww-add-ids') || '').split(',').filter(Boolean);
    if (!ids.length) return;
    var label = b.innerHTML;
    b.innerHTML = 'Adding…'; b.disabled = true;
    fetchWithTimeout(root() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: ids.map(function (id) { return { id: id, quantity: 1 }; }) })
    })
      .then(function (r) { if (!r.ok) throw r; return r.json(); })
      .then(function () {
        b.innerHTML = '\u2713 Added ' + ids.length + ' pieces';
        confirmAdd('\u2713 Added ' + ids.length + ' pieces to bag');
        setTimeout(function () { b.innerHTML = label; b.disabled = false; }, 2000);
      })
      .catch(function (errResponse) {
        // A batched cart/add.js call fails all-or-nothing \u2014 if one picked
        // piece is sold out, NONE of them get added. Redirecting to /cart
        // with no explanation used to leave the shopper guessing why
        // nothing happened; show the real reason instead and leave the
        // button usable so they can add the in-stock pieces individually.
        b.innerHTML = label; b.disabled = false;
        var fallbackMsg = "Couldn't add the full look \u2014 one or more pieces may be sold out. Try adding them individually.";
        if (errResponse && typeof errResponse.json === 'function') {
          errResponse.json()
            .then(function (data) { showToast((data && (data.description || data.message)) || fallbackMsg); })
            .catch(function () { showToast(fallbackMsg); });
        } else {
          showToast(fallbackMsg);
        }
      });
  });

  // Open all external links (outside this store's domain) in a new tab.
  // Catches footer socials, VIP group, and any menu link the merchant adds later.
  function markExternalLinks(scope) {
    var links = (scope || document).querySelectorAll('a[href^="http"]');
    links.forEach(function (a) {
      if (a.target === '_blank') return;
      var host;
      try { host = new URL(a.href).hostname; } catch (e) { return; }
      if (host && host !== window.location.hostname) {
        a.target = '_blank';
        var rel = (a.getAttribute('rel') || '').split(/\s+/).filter(Boolean);
        if (rel.indexOf('noopener') === -1) rel.push('noopener');
        if (rel.indexOf('noreferrer') === -1) rel.push('noreferrer');
        a.setAttribute('rel', rel.join(' '));
      }
    });
  }
  markExternalLinks(document);
  document.addEventListener('DOMContentLoaded', function () { markExternalLinks(document); });

  // Product recommendations ("You may also like") via Section Rendering API
  function loadRecommendations() {
    document.querySelectorAll('[data-ww-recs]').forEach(function (el) {
      var url = el.getAttribute('data-url');
      if (!url) return;
      fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-ww-recs]');
          if (fresh && fresh.innerHTML.trim()) {
            el.innerHTML = fresh.innerHTML;
            markExternalLinks(el);
          }
        })
        .catch(function () {});
    });
  }
  if (document.readyState !== 'loading') { loadRecommendations(); }
  else { document.addEventListener('DOMContentLoaded', loadRecommendations); }

  // Cart page quantity fields carry a server-rendered max (tracked inventory,
  // no-oversell variants only) — clamp typed/stepped values to it so a
  // shopper can't set a line item above real stock from the bag itself.
  function clampCartQty(el) {
    var max = el.getAttribute('max');
    if (max === null) return;
    var n = parseInt(el.value, 10);
    if (isNaN(n)) return;
    if (n > parseInt(max, 10)) { el.value = max; }
  }
  document.addEventListener('input', function (e) {
    if (e.target.matches && e.target.matches('[data-ww-cart-qty]')) { clampCartQty(e.target); }
  });
  document.addEventListener('change', function (e) {
    if (e.target.matches && e.target.matches('[data-ww-cart-qty]')) { clampCartQty(e.target); }
  });
})();
